import React from "react";
import PropTypes from 'prop-types';
import { DrawerNavigator, NavigationState, } from  "~/native-ui"

const getComponentFactory = (body) => {
    return class BodyComponent extends React.PureComponent {
        render() {
            return (
                <React.Fragment>
                    <NavigationState />
                    { body}
                </React.Fragment>
            );
        }
    }    
}



export class Drawer extends React.PureComponent {
    static propTypes = {
        showDrawer: PropTypes.bool,
        appBar: PropTypes.node.isRequired,
        body: PropTypes.node.isRequired,
    }

    get screens() {
        return [{
            name: "/",
            component: getComponentFactory(this.props.body)
        }]
    }
    
    render() {
        const drawerNavigatorProps = {
            screens: this.screens,
            drawerContent: this.props.appBar,
            showDrawer: this.props.showDrawer,
            isSmallScreen: this.props.isSmallScreen,
        }
        return (
            <DrawerNavigator { ...drawerNavigatorProps } />
        )
    }
}